const name = "@prismicio/adapter-sveltekit";
export {
  name
};
//# sourceMappingURL=package.json.js.map
